module.exports = __webpack_public_path__ + "static/media/ububu.22a3ebf6.png";